<!-- 设备管理页面 -->
<template>
    <div class="campus-announcement">
        <div class="Input-Row-Top">
            <!-- <h1 class="titleStyle">设备管理</h1> -->
            <!-- <el-row class="School-Effective">
                <el-col :span="6">
                    <el-form-item label="IMEI:">
                    <el-input v-model="form.imei" placeholder=''></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="RFID:">
                    <el-input v-model="form.rfid" placeholder=''></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="型号:">
                    <el-input v-model="form.dictionaryName" placeholder=''></el-input>
                </el-form-item></el-col>
                <el-col :span="6">
                    <el-form-item label="姓名:">
                    <el-input v-model="form.deviceName" placeholder=''></el-input>
                </el-form-item></el-col>
            </el-row> -->
            <el-row class="School-Effective">
                <el-col :span="8">
                    <el-form-item label="IMEI:" >
                    <el-input v-model="form.imei" placeholder=''></el-input>
                </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="号码:">
                    <el-input v-model="form.phoneNumber" placeholder=''></el-input>
                </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                    <el-form-item label="服务IP:">
                    <el-input v-model="form.toIP" placeholder=''></el-input>
                </el-form-item>
                </el-col> -->
                <!-- <el-col :span="6">
                    <el-form-item label="版本号:">
                    <el-input v-model="form.appVersion" placeholder=''></el-input>
                </el-form-item></el-col> -->
                <!-- <el-col :span="6">
                    <el-form-item label="蓝牙MAC:">
                    <el-input v-model="form.bluetoothMac" placeholder=''></el-input>
                </el-form-item></el-col> -->
                <el-col :span="8">
                    <el-form-item label="操作">
                        <el-select filterable v-model="formSourcesValue" placeholder="请选择数据来源">
                            <el-option label="其他" value="0"></el-option>
                            <el-option :label="item.name" :value="item.value" v-for="item in buttonData" :key="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-button size="medium" type="primary" class="searchBtn" @click="searchSouSuoClick">查询</el-button>
                <el-button size="medium" type="danger" @click="deleteClick" class="shanchu">批量删除</el-button>
            </el-row>
            <div>
            </div>
        </div>
        <div class="upload-box" v-if="  
            formSourcesValue == '2'||
            formSourcesValue == '3'||
            formSourcesValue == '5'
        ">
            <el-form-item label="所属用户："   >
                <el-select filterable v-model="theuserValue" placeholder="请选择数据来源">
                    <el-option label="其他" value="0"></el-option>
                    <el-option :label="item.label" :value="item.value" v-for="item in theuserList" :key="item.name"></el-option>
                </el-select>
            </el-form-item>
            <div class="upload-lef">
                <!-- <div @click="clickUpload">上传附件</div> -->
                <span class="upload-title">请选择要导入的数据文件：</span>
                <input class="upload" style="cursor: pointer;" id="inputFile" type="file" @change="getFile($event)" />
                <el-button type="primary" @click="uploadClick">上传</el-button>
            </div>
        </div>
        <!-- table表格 -->
        <div class="Table-Bottom">
            <el-table
                stripe
                :border="true"
                v-loading="loading"
                :header-cell-style="{background:'#F4F7FC',color:'#000', height:'40px' }"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                class="table-Style"
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
            >
                </el-table-column> 
                <el-table-column
                prop="deviceName"
                label="姓名"
                >
                </el-table-column>
                <el-table-column
                prop="rfid"
                label="RFID"
                >
                </el-table-column>
                <el-table-column
                prop="userName"
                label="所属用户"
                >
                </el-table-column>
                <el-table-column
                prop="phoneNumber"
                label="号码"
                >
                </el-table-column>
                <el-table-column
                prop="memberPhoneNumber"
                label="关联用户"
                >
                </el-table-column>
                <el-table-column
                prop="imei"
                label="IMEI"
                >
                </el-table-column>
                <el-table-column
                prop="dictionaryName"
                label="型号"
                >
                </el-table-column>
               
                <el-table-column
                prop="lastAck"
                label="最近活跃"
                >
                </el-table-column>
                <el-table-column
                prop="appVersion"
                label="版本号"
                show-overflow-tooltip>
                </el-table-column>
              
              
                <el-table-column
                prop="expirationTime"
                label="到期时间"
                >
                </el-table-column>
                
                <el-table-column
                prop="address"
                label="操作"
                show-overflow-tooltip>
                <template #default="scope">
                    <!-- {{ scope.row }} -->
                    <el-select v-model="scope.row.addressValue" placeholder="请选择数据来源" @change="addressClick(scope.row,scope.$index)">
                        <el-option label="请选择" value="0"></el-option>
                        <el-option :label="item.name" :value="item.value" v-for="item in addressValueList" :key="item.name"></el-option>
                    </el-select>
                </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
                <!-- <el-button @click="toggleSelection()">批量删除</el-button> -->
            </div>
            <div class="block">
                <!-- <span class="demonstration">直接前往</span> -->
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="prev, pager, next, jumper"
                :total="total">
                </el-pagination>
             </div>
        </div>

        <Add v-if="AddShow" :detailsObj='detailsObj' @AddShowClick="AddShowClick"></Add>
    </div>
</template>

<script>
import { 
    deviceListFind,
    deleteList,
    importNotAttendanceDevice,
    importAttendanceDevice,
    importTerminalDevice,
    deviceFind,
    familyNumberExport,
    deviceDataReport,
    menuGetUserTree,
    getButtonList,
} from '@/assets/api/api'
import { ElMessage } from 'element-plus'
import Add from './add/add.vue';
export default {
    components: {
        Add
    },
    data() {
        return {
            loading:true,
            currentPage3: 1,
            form:{
                outernetName:'',
                appVersion: '',
                bluetoothMac: '',
                deviceName: '',
                dictionaryName: '',
                imei: '',
                phoneNumber: '',
                rfid: '',
                toIP: ''
            },
            value:'',
            tableData: [],
            buttonData:[],
            multipleSelection: [],
            pageInfo: {
                page: 1,
                pageSize: 10,
            },
            total: 0,
            addressValueList: [
                {
                    name: '修改',
                    value: '1'
                },
                {
                    name: '删除',
                    value: '2'
                },
                // {
                //     name: '禁止',
                //     value: '3'
                // },
                // {
                //     name: '亲情号',
                //     value: '4'
                // },
                // {
                //     name: '接口定位',
                //     value: '5'
                // },
            ],
            formSourcesValue: '0',
            formSourcesList: [
                {
                    name: '新增终端',
                    value: '1'
                },
                {
                    name: '导入非考勤数据',
                    value: '2'
                },
                {
                    name: '导入考勤数据',
                    value: '3'
                },
                // {
                //     name: '批量考勤换机',
                //     value: '4'
                // },
                {
                    name: '导入终端数据',
                    value: '5'
                },
                // {
                //     name: '导入智慧笔和跳缉数据',
                //     value: '6'
                // },
                // {
                //     name: '下载非考勤教据模版',
                //     value: '7'
                // },
                {
                    name: '导出数据报表',
                    value: '8'
                },
                {
                    name: '导出亲情号',
                    value: '9'
                },
            ],
            tempFile: "", //文件
            theuserValue: '',
            theuserList: [
                
            ],
            AddShow: false,
            detailsObj: {},
            addressIndex: null  
        };
    },
    created() {

    },
    mounted() {
        this.searchClick()
        this.menuGetUserTreeGet()
        this.getButtonList()
        console.log('搜索', JSON.parse(localStorage.getItem('user')).id,localStorage.getItem('token'))
    },
    watch: {
        formSourcesValue (val) {
            console.log(val,'监听大下拉框');
            if (val == 1) {
                this.AddShow = true
            } else if (val == 9 || val == 8) {
                this.deriveFamily()
            } 
        }
    },
    methods: {
        menuGetUserTreeGet() {
            let params = {
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            menuGetUserTree(params).then((res)=> {
                console.log(res,res.data.data[0],'获取--所属用户下拉框');
                this.theuserList = [...res.data.data, ...res.data.data[0].children]
                for (let item of this.theuserList) {
                    item.label = item.username
                    item.value = item.id
                }
            }).catch((err)=> {
                console.log(err);
            })
        },
        AddShowClick () {
            console.log(22222);
            this.AddShow = false
            this.formSourcesValue = '0'
            this.detailsObj = {}
            if ( this.addressIndex != null ) {
                this.tableData[this.addressIndex].addressValue = '0'
            }
            this.searchClick()
        },
        addressClick(item,index) {
            console.log(item,index,'下拉触发');
            this.addressIndex = index
            if (item.addressValue == 2) {
                this.multipleSelection.push(item)
                this.deleteClick()
            } else if (item.addressValue == 1) {
                this.deviceFindClick(item)
            }
        },
        deviceFindClick (item) {
            let params = {
                deviceId: item.deviceId 
            }
            deviceFind(params).then((res)=> {
                this.detailsObj = res.data
                this.AddShow = true
            }).catch((err)=> {
                console.log(err);
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection,val,'this.multipleSelection');
        },
        deleteClick() {
            if( !this.multipleSelection.length) {
                ElMessage.error('请先选中需要删除的终端。')
            } else {
                let arr = []
                for(let value of  this.multipleSelection) {
                    console.log(value.deviceId,5555555);
                    arr.push(value.deviceId)
                }
                let params = {
                    userId: JSON.parse(localStorage.getItem('user')).id,
                    deviceIds:arr
                }
                deleteList(params).then((res)=> {
                    console.log(res,'删除接口');
                    // this.searchClick()
                    ElMessage({message: '删除成功',type: 'success',})
                    this.multipleSelection = []
                    this.searchClick()
                }).catch((err)=> {
                    console.log(err);
                })
            }
        },
        searchSouSuoClick () {
            this.pageInfo.page = 1
            this.searchClick()
        },
        searchClick () {
            let Id = JSON.parse(localStorage.getItem('user')).id
            let params = {
                appVersion: this.form.appVersion,
                bluetoothMac: this.form.bluetoothMac,
                deviceName: this.form.deviceName,
                dictionaryName: this.form.dictionaryName,
                imei: this.form.imei,
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
                phoneNumber: this.form.phoneNumber,
                rfidDecimal: this.form.rfid,
                toIP: this.form.toIP,
                userId: Id
            }
            
            deviceListFind(params).then((res)=> {
                console.log(res,'列表接口');
                // console.log('this', this)
                // this.$set(this.pageInfo,'addressValue','')
                if ( res.data.list ) {
                    for(let item of res.data.list ) {
                        item.addressValue = '0'
                    }
                    this.tableData =  res.data.list 
                    console.log(this.tableData);
                    this.total = res.data.total
                    this.loading = false
                }
            }).catch((err)=> {
                console.log(err);
            })
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageInfo.page = val
            this.searchClick()
        },
         // 上传
         uploadClick() {
            let index = this.tempFile.name.lastIndexOf(".");
            let fileName = this.tempFile.name.substr(index + 1);
            var filetypes = [
                "jpg",
                "png",
                "gif",
                "jpeg",
                "doc",
                "ppt",
                "xls",
                "pdf",
                "docx",
                "xlsx",
            ];
            if (filetypes.includes(fileName)) {
                if (this.tempFile) {
                    let fileSize = this.tempFile.size / (1024 * 1024 * 60);
                    // if (fileSize > 1) {
                    //     this.$message.error({ message: "文件不能超过60M！" });
                    // } else {
                        if (this.tempFile.name) {
                            let formData = new FormData();
                            console.log(formData,8888888);
                            formData.append("file", this.tempFile);
                            console.log(this.tempFile,formData.getAll('file'));
                            if (this.formSourcesValue == '2') { 
                                importNotAttendanceDevice(formData,this.theuserValue).then((res)=> {
                                    console.log(res);
                                    ElMessage({message: '非考勤数据上传成功',type: 'success',})
                                }).catch((err)=> {
                                    // console.log();
                                    ElMessage.error("上传失败")
                                })
                            } else if (this.formSourcesValue == '3') {
                                importAttendanceDevice(formData,this.theuserValue).then((res)=> {
                                    console.log(res);
                                    ElMessage({message: '考勤数据上传成功',type: 'success',})
                                }).catch((err)=> {
                                    // console.log();
                                    ElMessage.error("上传失败")
                                })
                            }else if (this.formSourcesValue == '5') {
                                importTerminalDevice(formData,this.theuserValue).then((res)=> {
                                    console.log(res);
                                    ElMessage({message: '终端数据上传成功',type: 'success',})
                                }).catch((err)=> {
                                    // console.log();
                                    ElMessage.error("上传失败")
                                })
                            }
                            
                        }
                    // }
                }
            } else {
                ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
            }
            
        },
        getFile(event) {
            this.tempFile = event.target.files[0];
        },
        deriveFamily (val) {
            let params = {
                appVersion: this.form.appVersion,//版本号
                bluetoothMac: this.form.bluetoothMac, // 蓝牙MAC
                deviceName: this.form.deviceName, // 姓名
                dictionaryName: this.form.dictionaryName, // 型号
                imei: this.form.imei, // imei
                phoneNumber: this.form.phoneNumber, // 号码
                rfidDecimal: this.form.rfid, // rfid
                userId: JSON.parse(localStorage.getItem('user')).id,
            }
            if (this.formSourcesValue == 8) {
                deviceDataReport(params).then((res)=> {
                    this.handleExport(res.data,'数据报表.xls')
                }).catch((err)=> {
                    ElMessage.error("导出数据报表失败")
                })
            } else if (this.formSourcesValue == 9) {
                familyNumberExport(params).then((res)=> {
                    this.handleExport(res.data,'亲情号.xls')
                }).catch((err)=> {
                    ElMessage.error("导出亲情号失败")
                })
            }
        },
       
        handleExport(data,name) {
            // 动态创建iframe下载文件
            let fileName = name;
            if (!data) {
                return;
            }
            let blob = new Blob([data], { type: "application/octet-stream" });
            console.log(blob);
            if ("download" in document.createElement("a")) {
                // 不是IE浏览器
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // 下载完成移除元素
                window.URL.revokeObjectURL(url); // 释放掉blob对象
            } else {
                // IE 10+
                window.navigator.msSaveBlob(blob, fileName);
            }
        },

      getButtonList(){
        const params = {
          userId: JSON.parse(localStorage.getItem('user')).id,
          menuName:"终端管理",
        }
        getButtonList(params).then((res)=>{
          this.buttonData = res.data.data;
          console.log(res,'按钮权限');
        }).catch((err=>{
          console.log(err,'按钮异常');
          this.$message({
            type:'error',
            message:'获取按钮异常，请重试'
          })
        }))
      },

    },
};
</script>

<style scoped lang="scss" >
.campus-announcement {
    height:  96%;
    .Input-Row-Top{
        height: 100px ;
        background-color: #fff;
        border-radius: 15px;
        display: flex;
         align-items: center;
       .titleStyle{
        // margin-right: 25%;
        // margin-left: 40px;
        font-size: 20px;
        font-weight: 700;
        width: 35%;
       }
    .searchBtn{
        // background-color: #1BC896;
        border-radius: 15px;
    }

    /deep/ {
        .el-col-8{
            // margin-top: 15px;
            max-width: 15%;
            margin-right: 80px; 
            // margin-left: 30px;
        }
        .el-input--small .el-input__wrapper{
          text-align: right;
          height: 35px;
          line-height: 35px;        
          border-radius: 15px;
        }
        .el-form-item--small .el-form-item__label{
            margin-left: 20px;
            line-height: 35px;
            font-weight: 700;
        }

        .el-button--medium{
            margin-top: 15px;
            margin-left: 100px;
        }
        .el-form-item{
            width: 150%;
            margin: 15px;
        }
    
    }
  }
  .Table-Bottom{
    background-color: #fff;
    // height: calc(100% - 320px);
    height: 87%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 10px;
    margin-top: 15px;
    border-radius: 15px;
    .table-Style{
        // border-radius: 15px;
        margin-top: 15px;

    }
    
        /deep/{
            .el-table--enable-row-transition .el-table__body td.el-table__cell{
            // border:none !important;
            text-align: center;

          }
          
            .el-table_1_column_3 {
                // width: 300px !important;
                // color: pink !important;
            }
         .el-table tr {
            font-size: 15px;
            height: 40px !important;
            
        }
        .el-table th.el-table__cell>.cell {
            font-weight: 700;
            text-align: center;
        }
        }
}

.block{
    margin-left: 1100px;
}
.shanchu {
    // margin-right: 5px;
    // position: absolute;
    // top: 40px;
    // right: 20px;
    margin-top: 15px;
    margin-left: 25px !important;
    border-radius: 15px;
}
.upload-box {
    margin-top: 15px;
    .upload-lef {
        margin-left: 20px;
        font-size: 14px;
        .upload-title {}
    }
    /deep/ {

        .el-table--enable-row-transition .el-table__body td.el-table__cell{
                    font-size: 40px;
                    font-weight: 700;
        }
      
        // .el-form-item--small .el-form-item__content {
            //     height: 40px;
            //     line-height: 40px;
            // }
            .el-select .el-input__inner {
                height: 35px;
            }
            
          
            .el-form-item--small .el-form-item__label{
                margin-left: 20px;
                line-height: 35px;
                color: black;
            }
            
            .el-upload-list {
                // dis
                font-size: 80px;
            }
            
            
        }
    }
}
</style>
